// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Ql_Ml","title":"Header_title__jXlQv","left":"Header_left__3_PyN","clinicName":"Header_clinicName__35iEP"};